export type SocketEventData<T> = {
  data: T;
  user: string;
  type: string;
  status: boolean;
};

export type SocketEvent<T> = {
  event: string;
  data: SocketEventData<T>;
};

export type SocketConfig = {
  [serviceName: string]: {
    host: string;
  };
};

export enum SocketServiceEnum {
  GMAIL_SERVICE = "gmailService",
  ROOT_BACKEND_SERVICE = "rootBackendService",
}
